import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

import {onMounted, ref} from "vue";
	import {FetchData} from "../utils/FetchData";
	import CircuitCard from '../components/CircuitCard.vue';
	import FetchOptions from "../interfaces/FetchOptions";
	import ModalWindow from '../components/ModalWindow.vue';
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'CircuitsPage',
  setup(__props) {

	const circuits = ref([]);
	const deletingCircuit = ref({});
	const modalVisible = ref(false);
	const loading = ref(true);

	onMounted(() => {
		RetrieveCircuits();
	});

	async function RetrieveCircuits() {
		const data = await FetchData('circuits');
		if(!data.isError) {
			data.data.sort((a: object, b: object) => (a.country.toLowerCase() > b.country.toLowerCase()) ? 1 : -1);
			circuits.value = data.data;
		}
		loading.value = false;
	}

	function addCircuit() {
		circuits.value.unshift({});
	}

	function onDeleteCircuit(circuit: object) {
		if(circuit.id == undefined) {
			circuits.value.shift();
			return;
		}

		modalVisible.value = true;
		deletingCircuit.value = circuit;
	}

	async function confirmAccept() {
		modalVisible.value = false;

		const options: FetchOptions = {
			method: 'DELETE'
		};
		const data = await FetchData("circuits/" + deletingCircuit.value.id, options);
		if(!data.isError)
			circuits.value = circuits.value.filter(x => x.id != deletingCircuit.value.id);
	}

	function confirmDeny() {
		modalVisible.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "content-box",
      onClick: addCircuit
    }, " Circuit toevoegen "),
    (!loading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(circuits.value, (circuit) => {
          return (_openBlock(), _createBlock(CircuitCard, {
            key: circuit,
            circuit: circuit,
            onDeleteCircuit: onDeleteCircuit
          }, null, 8, ["circuit"]))
        }), 128))
      : (loading.value)
        ? (_openBlock(), _createBlock(LoadingCircleAnimation, { key: 1 }))
        : _createCommentVNode("", true),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Bevestigen ")
      ]),
      content: _withCtx(() => [
        _createTextVNode(" Weet je zeker dat je circuit '" + _toDisplayString(deletingCircuit.value.country) + " - " + _toDisplayString(deletingCircuit.value.circuit) + "' en alle bijbehorende gegevens wilt verwijderen? ", 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: confirmAccept }, "Ja"),
        _createElementVNode("button", { onClick: confirmDeny }, "Nee")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalVisible.value]
    ])
  ], 64))
}
}

})